<template>
  <div>
    <vs-table class="border-0 border-solid border-t border-silver-gray" ref="table"
      :max-items="tableData.drivers.length" v-if="tableData && tableData.drivers.length"
      :data="tableData.drivers || []">
      <template slot="thead">
        <vs-th v-for="(header, idx) in headers" :key="idx" class="text-black font-semibold text-sm">
          {{ header }}
        </vs-th>
      </template>
      <template v-if="tableData && tableData.drivers.length">
        <tbody @click="changeModalOpen">
          <vs-tr v-for="(tr, indextr) in tableData.drivers" :key="indextr"
            :class="[indextr % 2 === 0 ? 'bg-soft-gray' : '']">
            <vs-td>
              {{ indextr + 1 }}
            </vs-td>
            <vs-td>
              {{ tr.name }}
            </vs-td>
            <vs-td>
              {{ tr.odometer_change }}
            </vs-td>
            <vs-td>
              {{ tr.driving_time }}
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
      headers: ['#', 'Name', 'Odometer change', 'Driving time'],
    }
  },
  methods: {
    changeModalOpen() {
      this.$emit('open');
    },
  }
};
</script>

<style scoped></style>
